import React from 'react';
import { appConfig } from '../config';
import axios from 'axios';
import { AppThunkAction } from './index';
import { showSnackBarMsg } from './snackbar';
import { FormattedMessage } from 'react-intl';
import { Customer } from '../types/customer';
import metaApi from '../api/meta/metaApi';
import { MetaAccount, MetaEmbedSignup, PhoneNumber } from '../types/meta/metaAccount';
import { AnyAction } from 'redux';
import { getUserWhatsappConfig } from './login';

export function setMetaAdministrationCustomers(customers: Customer[]): AppThunkAction {
  return (dispatch) => {
    dispatch({
      type: 'SET_META_ADMIN_CUSTOMERS',
      customers: customers,
    });
  };
}

export function setMetaAdministrationConfigs(configs: MetaAccount[]): AppThunkAction {
  return (dispatch) => {
    dispatch({
      type: 'SET_META_ADMIN_CONFIGS',
      configs: configs,
    });
  };
}

export function setMetaAdministrationConfig(config: MetaAccount): AppThunkAction {
  return (dispatch) => {
    dispatch({
      type: 'SET_META_ADMIN_SELECTED_CONFIG',
      config: config,
    });
  };
}

export function resetMetaAdministrationConfig(): AppThunkAction {
  return (dispatch) => {
    dispatch({
      type: 'SET_META_ADMIN_SELECTED_CONFIG',
      config: {},
    });
  };
}

export function getMetaConfigs(): AppThunkAction {
  return (dispatch) => {
    dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: true });
    metaApi.accounts.getAll()
      .then((metaAccounts: MetaAccount[]) => {
        dispatch(setMetaAdministrationConfigs(metaAccounts));
        dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: false });
      })
      .catch((error) => {
        
        dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: false });
      });
  };
}

export function addMetaConfig(values: MetaAccount): AppThunkAction {
  return (dispatch) => {
    dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: true });
    metaApi.accounts.add(values)
      .then(() => {
        dispatch(getMetaConfigs());
        dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: false });
        dispatch(showSnackBarMsg(<FormattedMessage id="data.fetching.dataSaved" />, 'success'));
      })
      .catch((error) => {
        
        dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: false });
        dispatch(showSnackBarMsg(<FormattedMessage id="data.fetching.dataFailed" />, 'error'));
      });
  };
}

export function getOneMetaConfig(id: string): AppThunkAction {
  return (dispatch) => {
    metaApi.accounts.getById(id)
      .then((metaConfig: MetaAccount) => {
        dispatch(setMetaAdministrationConfig(metaConfig));
      })
      .catch(() => {});
  };
}

export function updateMetaConfig(item: MetaAccount): AppThunkAction {
  return (dispatch, getState) => {
    const id = getState().meta.selectedConfig.businessAccountId!;
    metaApi.accounts.update(id, item)
      .then(() => {
        dispatch({ type: 'UPDATE_META_CONFIG', payload: item });
        dispatch(getMetaConfigs());
        dispatch(showSnackBarMsg(<FormattedMessage id="data.fetching.dataSaved" />, 'success'));
      })
      .catch((error) => {
        
        dispatch(showSnackBarMsg(<FormattedMessage id="data.fetching.dataFailed" />, 'error'));
      });
  };
}

export function handleSetMetaConfigEnabled(businessAccountId: string): AppThunkAction {
  return (dispatch) => {
    metaApi.accounts.enable(businessAccountId)
      .then(() => {
        dispatch(getMetaConfigs());
        dispatch(showSnackBarMsg(<FormattedMessage id="data.fetching.dataSaved" />, 'success'));
      })
      .catch((error) => {
        
        dispatch(showSnackBarMsg(<FormattedMessage id="data.fetching.dataFailed" />, 'error'));
      });
  };
}

export function handleSetMetaConfigDisabled(businessAccountId: string): AppThunkAction {
  return (dispatch) => {
    metaApi.accounts.disable(businessAccountId)
      .then(() => {
        dispatch(getMetaConfigs());
        dispatch(showSnackBarMsg(<FormattedMessage id="data.fetching.dataSaved" />, 'success'));
      })
      .catch((error) => {
        
        dispatch(showSnackBarMsg(<FormattedMessage id="data.fetching.dataFailed" />, 'error'));
      });
  };
}

export function deleteOneMetaConfig(id: string): AppThunkAction {
  return (dispatch) => {
    metaApi.accounts.delete(id)
      .then(() => {
        dispatch(getMetaConfigs());
      })
      .catch(() => {});
  };
}

export function getCustomersForForm(): AppThunkAction {
  return (dispatch) => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    };
    const url = `${appConfig.URL_REST}customers?page=0&size=10000&sort=name,asc&full=false`;
    axios
      .get(url, config)
      .then((res) => {
        const customersDataForForm =
          res.data &&
          res.data._embedded &&
          res.data._embedded.customers.map((c: $TSFixMe) => {
            return {
              id: c.id,
              name: c.name,
              shortName: c.shortName,
              currency: c.defaultCurrency,
            };
          });
        dispatch(setMetaAdministrationCustomers(customersDataForForm));
      })
      .catch(() => {});
  };
}

export function getMetaConfigsByTenantId(): AppThunkAction {
  return (dispatch, getState) => {
    dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: true });
    const tenantId = getState().login.userData.customerUuid!;
    metaApi.accounts.getAllByTenantId(tenantId)
      .then((metaAccounts: MetaAccount[]) => {
        dispatch(setMetaAdministrationConfigs(metaAccounts));
        dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: false });
      })
      .catch((error) => {
        
        dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: false });
      });
  };
}

export function setDefaultMetaConfig(defaultAccount: MetaAccount): AppThunkAction {
  return (dispatch) => {
    dispatch({
      type: 'SET_DEFAULT_META_CONFIG',
      defaultAccount: defaultAccount,
    });
  };
}

export function setWhatsappPhoneNumbers(phoneNumbers: PhoneNumber[]): AppThunkAction {
  return (dispatch) => {
    dispatch({
      type: 'SET_WHATSAPP_PHONE_NUMBERS',
      phoneNumbers: phoneNumbers,
    });
  };
}

export function getDefaultMetaConfig(): AppThunkAction {
  return (dispatch, getState) => {
    dispatch({ type: 'SET_DEFAULT_META_CONFIG_LOADING', payload: true });
    metaApi.accounts.getDefault()
      .then((metaAccount: MetaAccount) => {
        dispatch(setDefaultMetaConfig(metaAccount));
        dispatch({ type: 'SET_DEFAULT_META_CONFIG_LOADING', payload: false });
      })
      .catch((error) => {
        
        dispatch({ type: 'SET_DEFAULT_META_CONFIG_LOADING', payload: false });
      });
  };
}

export function getPhoneNumbersByBusinessAccountId(businessAccountId: string): AppThunkAction {
  return (dispatch) => {
    dispatch({ type: 'SET_WHATSAPP_PHONE_NUMBERS_LOADING', payload: true });
    metaApi.whatsappPhoneNumber.getPhoneNumbersById(businessAccountId)
      .then((whatsappPhoneNumbers: PhoneNumber[]) => {
        dispatch(setWhatsappPhoneNumbers(whatsappPhoneNumbers));
        dispatch({ type: 'SET_WHATSAPP_PHONE_NUMBERS_LOADING', payload: false });
      })
      .catch((error) => {
        
        dispatch({ type: 'SET_WHATSAPP_PHONE_NUMBERS_LOADING', payload: false });
      });
  };
}

export function syncWhatsappPhones(): AppThunkAction {
  return (dispatch) => {
    dispatch({ type: 'SET_WHATSAPP_PHONE_NUMBERS_LOADING', payload: true });
    metaApi.accounts
      .getSyncedPhoneNumbersById()
      .then((metaAccounts: MetaAccount[]) => {
        dispatch(setMetaAdministrationConfigs(metaAccounts));
        const firstAccount = metaAccounts[0];
        dispatch(setWhatsappPhoneNumbers(firstAccount?.phoneNumbers || []));
        dispatch({ type: 'SET_WHATSAPP_PHONE_NUMBERS_LOADING', payload: false });
      })
      .catch((error) => {
        
        dispatch({ type: 'SET_WHATSAPP_PHONE_NUMBERS_LOADING', payload: false });
      });
  };
}

export function setPhoneNumbersDialogOpen(flag: boolean): AnyAction {
  return { type: 'SET_WHATSAPP_PHONE_NUMBERS_DIALOG_OPEN', payload: flag };
}

export function addMetaEmbedSignupConfig(values: MetaEmbedSignup): AppThunkAction<Promise<void>> {
   return async (dispatch) => {
    dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: true });

    try {
      await metaApi.accounts.addEmbedSignupAccount(values);
      dispatch(getMetaConfigsByTenantId());
      dispatch(getUserWhatsappConfig());
      dispatch(showSnackBarMsg(<FormattedMessage id="data.fetching.dataSaved" />, 'success'));
      return Promise.resolve();
    } catch (error) {
      
      dispatch(showSnackBarMsg(<FormattedMessage id="data.fetching.dataFailed" />, 'error'));
      return Promise.reject(error);
    } finally {
      dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: false });
    }
  };
}

export function getSyncedWaba(): AppThunkAction {
  return (dispatch) => {
    dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: true });
    metaApi.accounts.getSyncedPhoneNumbersById()
      .then((metaAccounts: MetaAccount[]) => {
        dispatch(setMetaAdministrationConfigs(metaAccounts));
        dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: false });
      })
      .catch((error) => {
        
        dispatch({ type: 'SET_META_CONFIGS_LOADING', payload: false });
      });
  };
}

